<template>
<section>
	<div id="contents" class="contents">
		<content-title></content-title>
		<slot></slot>
	</div>
</section>
</template>

<script>
import ContentTitle from '@/components/ContentTitle.vue'
export default {
	components:{
		ContentTitle,
	}
}
</script>